// extracted by mini-css-extract-plugin
module.exports = {"icon":"T_cj","font-size-small":"T_dr","fontSizeSmall":"T_dr","font-size-default":"T_ds","fontSizeDefault":"T_ds","font-size-large":"T_dt","fontSizeLarge":"T_dt"};